module.exports = __webpack_public_path__ + "static/media/newUser_viejo.421d06c3.svg";